import React from 'react';
import { useLabels, usePrefs } from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';

const VehicleTagline = () => {
	const labels = useLabels();
	const { vehicleTaglineLabel, vehicleTaglineClasses } = usePrefs();

	return (
		<p
			className={setClassNames([
				'tagline',
				...vehicleTaglineClasses.split(' ')
			])}
			data-testid="tagline"
		>
			{labels.get(vehicleTaglineLabel)}
		</p>
	);
};

export default VehicleTagline;
